/**
 * Event to add promotion banners to landing page
 */

klevu.coreEvent.attach("setRemoteConfigLanding", {
	name: "eventAddPromotionBannerLandingPage",
	fire: function () {
		var mapBanner = function () {
			// klevu_banner value is coming from https://js.klevu.com/klevu-js-v1/klevu-js-api/{JS_API_KEY}-banner.js
			if (typeof klevu_banner === "undefined") return;

			var landing_bannerList = [];
			klevu_banner.forEach(function (item) {
				if (item.showOnLandingPage) {
					landing_bannerList.push({
						default: item.showForTerms === null,
						id: item.bannerRef,
						name: item.bannerAltTag,
						src: item.bannerImg,
						click: item.redirectUrl,
						term: item.showForTerms,
						position: item.position,
					});
				}
			});

			return landing_bannerList;
		};

		var landing_promo_banners = mapBanner();

		var landingPromoBanners = klevu.dictionary("promo-banners");
		landingPromoBanners.mergeFromGlobal();
		landingPromoBanners.addElement("landing", JSON.stringify(landing_promo_banners));
		landingPromoBanners.mergeToGlobal();

		klevu.search.landing.getScope().template.setTemplate(klevu.dom.helpers.getHTML("#klevuLandingPromotionBanner"), "klevuLandingPromotionBanner", true);
		klevu.search.landing.getScope().chains.template.render.addBefore("renderResponse", {
			name: "appendBanners",
			fire: function (data, scope) {
				if (data.context.isSuccess) {
					data.template.banners = [];

					var defaultBanner;
					var isDefaultAppear = true;
					var bannerList = [];
					var landingPromoBanners = klevu.dictionary("promo-banners");
					landingPromoBanners.mergeFromGlobal();
					var landingElement = landingPromoBanners.getElement("landing");
					if (landingElement && landingElement.length && landingElement != "landing") {
						landingElement = JSON.parse(landingElement);
						if (landingElement && landingElement.length) {
							bannerList = landingElement;
						}
					}
					if (bannerList.length) {
						klevu.each(bannerList, function (index, value) {
							if (value.default) {
								defaultBanner = value;
							}
							if (value.term && value.term.length > 0 && value.term.indexOf(data.context.term) !== -1) {
								data.template.banners.push(value);
								isDefaultAppear = false;
							}
						});
						if (isDefaultAppear && defaultBanner) {
							data.template.banners.push(defaultBanner);
						}
					}
				}
			}
		});
	}
});



// WEBPACK FOOTER //
// ./klevu/klevu-landing-promotion-banner.js